module.exports = __webpack_public_path__ + "img/1F1FF-1F1FC.9895a365.svg";